/*
 * File: getAttendanceLabel.ts
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */

export type AttendanceValue = 'present' | 'absent' | 'no_permit' | null;

/**
 * Converts attendance enum values to human-readable display labels.
 *
 * @param attendance - The attendance value
 * @returns Human-readable label for the attendance status
 *
 * @example
 * getAttendanceLabel('present') // 'Present'
 * getAttendanceLabel('no_permit') // 'No Permit'
 */
export function getAttendanceLabel(attendance: string | null): string {
  switch (attendance) {
    case 'present':
      return 'Present';
    case 'absent':
      return 'Absent';
    case 'no_permit':
      return 'No Permit';
    default:
      return 'Unknown';
  }
}